import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { Shield, Clock, FileText, MapPin } from 'lucide-react';
import '../styles/why-choose-us.css';

const WhyChooseUs = () => {
  const sectionRef = useRef(null);
  const isInView = useInView(sectionRef, { once: true, margin: '-100px' });

  const reasons = [
    {
      icon: Shield,
      title: 'Calidad Garantizada',
      description: 'Materiales de primera calidad y acabados profesionales con garantía extendida en todos nuestros trabajos.',
    },
    {
      icon: Clock,
      title: 'Respuesta en 24h',
      description: 'Atendemos tu solicitud en menos de 24 horas. Servicio de urgencias disponible para emergencias.',
    },
    {
      icon: FileText,
      title: 'Transparencia Total',
      description: 'Presupuestos detallados sin letra pequeña. Lo que presupuestamos es lo que pagas, sin sorpresas.',
    },
    {
      icon: MapPin,
      title: 'Presencia Local',
      description: 'Conocemos la Costa Blanca. Equipo local con más de 20 años trabajando en toda la provincia.',
    },
  ];

  return (
    <section className="why-choose-us" ref={sectionRef}>
      <div className="why-container">
        <motion.div
          className="section-header centered"
          initial={{ opacity: 0, y: 30 }}
          animate={isInView ? { opacity: 1, y: 0 } : { opacity: 0, y: 30 }}
          transition={{ duration: 0.6 }}
        >
          <span className="section-label light">POR QUÉ ELEGIRNOS</span>
          <h2 className="section-title light">Tu Socio de Confianza en Construcción</h2>
        </motion.div>

        <div className="reasons-grid">
          {reasons.map((reason, index) => {
            const Icon = reason.icon;
            return (
              <motion.div
                key={index}
                className="reason-card"
                initial={{ opacity: 0, y: 30 }}
                animate={isInView ? { opacity: 1, y: 0 } : { opacity: 0, y: 30 }}
                transition={{ duration: 0.6, delay: index * 0.15 }}
              >
                <div className="reason-icon">
                  <Icon size={32} strokeWidth={1.5} />
                </div>
                <h3 className="reason-title">{reason.title}</h3>
                <p className="reason-description">{reason.description}</p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;